// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useRef } from "react";
import { Portal } from "@chakra-ui/react";
import {
  Overlays,
  MainWrapper,
  Header,
  HeaderText,
  IconWrapper,
  CloseWrapper,
  CanvasWrapper,
  Button,
  MessageText
} from "./styles";
import Icons from "src/icons";

type Props = {
  setImageModal: Function,
  canvasRef: any,
  handleUpload: Function,
  setIsInputFocused: Function
};

const ImagePasteModal = ({
  setImageModal,
  canvasRef,
  handleUpload,
  setIsInputFocused
}: Props) => {
  const modalRef = useRef(null);

  const close = () => {
    setImageModal(false);
    setIsInputFocused(false);
  };

  return (
    <Portal>
      <Overlays onClick={close}>
        <MainWrapper ref={modalRef}>
          <Header>
            <IconWrapper>
              <Icons type="imageStack" />
              <HeaderText>{i18n.t(k.UPLOAD_IMAGE)}</HeaderText>
            </IconWrapper>
            <CloseWrapper>
              <Icons type="close" />
            </CloseWrapper>
          </Header>
          <MessageText>{i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_UPLOA)}</MessageText>
          <CanvasWrapper>
            <canvas ref={canvasRef} />
          </CanvasWrapper>
          <Button onClick={handleUpload}>{i18n.t(k.UPLOAD)}</Button>
        </MainWrapper>
      </Overlays>
    </Portal>
  );
};

export default ImagePasteModal;
